// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.midi-keyboard-output-mapping-configurator {
  .output-mapping-row {
    max-width: 540px;
    display: grid;
    grid-template-columns: 28px 40px 1fr 240px;
    margin-bottom: 4px;
    padding-bottom: 1px;
    border-bottom: 1px solid #333;

    .output-connectable-name {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      margin-bottom: 5px;

      input {
        flex: 0;
        display: inline;
        height: 15px;
        font-size: 13px;
        flex: 1;
        margin-left: 4px;
      }
    }

    .midi-control-index {
      margin-top: auto;
      margin-bottom: 5px;
    }

    input {
      background-color: rgb(54, 54, 54);
      color: rgb(221, 221, 221);
      outline: none;
      border: none;
      margin-right: 4px;
      padding-top: 3px;
      padding-bottom: 3px;
      padding-left: 3px;
      padding-right: 3px;
      box-sizing: content-box;
    }
  }

  .add-output-mapping-prompt {
    margin-top: 10px;
  }
}

.output-mapping-scale-and-shift-controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Hack, 'Input Mono', Menlo, Monaco, Consolas, 'Courier New', monospace;
  font-size: 12px;

  .top {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-bottom: 3px;
  }

  .log-range-checkbox-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  .title {
    text-align: center;
    margin-top: 3px;
    flex: 1;
  }
}

.delete-mapping-button {
  height: 20px;
  width: 20px;
  padding: 0;
  font-size: 23px;
  line-height: 0;
  font-weight: bold;
  color: #aa3333;
  margin-top: auto;
  margin-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/midiKeyboard/MidiKeyboardOutputMappingConfigurator.css"],"names":[],"mappings":"AAAA;EACE;IACE,gBAAgB;IAChB,aAAa;IACb,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;;IAE7B;MACE,aAAa;MACb,yBAAyB;MACzB,qBAAqB;MACrB,kBAAkB;;MAElB;QACE,OAAO;QACP,eAAe;QACf,YAAY;QACZ,eAAe;QACf,OAAO;QACP,gBAAgB;MAClB;IACF;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,iCAAiC;MACjC,yBAAyB;MACzB,aAAa;MACb,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;MAChB,mBAAmB;MACnB,iBAAiB;MACjB,kBAAkB;MAClB,uBAAuB;IACzB;EACF;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kFAAkF;EAClF,eAAe;;EAEf;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,OAAO;EACT;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".midi-keyboard-output-mapping-configurator {\n  .output-mapping-row {\n    max-width: 540px;\n    display: grid;\n    grid-template-columns: 28px 40px 1fr 240px;\n    margin-bottom: 4px;\n    padding-bottom: 1px;\n    border-bottom: 1px solid #333;\n\n    .output-connectable-name {\n      display: flex;\n      justify-content: flex-end;\n      align-items: flex-end;\n      margin-bottom: 5px;\n\n      input {\n        flex: 0;\n        display: inline;\n        height: 15px;\n        font-size: 13px;\n        flex: 1;\n        margin-left: 4px;\n      }\n    }\n\n    .midi-control-index {\n      margin-top: auto;\n      margin-bottom: 5px;\n    }\n\n    input {\n      background-color: rgb(54, 54, 54);\n      color: rgb(221, 221, 221);\n      outline: none;\n      border: none;\n      margin-right: 4px;\n      padding-top: 3px;\n      padding-bottom: 3px;\n      padding-left: 3px;\n      padding-right: 3px;\n      box-sizing: content-box;\n    }\n  }\n\n  .add-output-mapping-prompt {\n    margin-top: 10px;\n  }\n}\n\n.output-mapping-scale-and-shift-controls {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: Hack, 'Input Mono', Menlo, Monaco, Consolas, 'Courier New', monospace;\n  font-size: 12px;\n\n  .top {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    margin-bottom: 3px;\n  }\n\n  .log-range-checkbox-wrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    align-items: center;\n  }\n\n  .title {\n    text-align: center;\n    margin-top: 3px;\n    flex: 1;\n  }\n}\n\n.delete-mapping-button {\n  height: 20px;\n  width: 20px;\n  padding: 0;\n  font-size: 23px;\n  line-height: 0;\n  font-weight: bold;\n  color: #aa3333;\n  margin-top: auto;\n  margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
